// extracted by mini-css-extract-plugin
export default {"greeting":"Information_greeting__LSFGe","header":"Information_header__iceQe","btn":"Information_btn__r12PQ"};